// extracted by css-extract-rspack-plugin
export default {"input":"NativeSelect-module__input___CiV45"};